/**
 * Net worth as of right now, straight from the balances entered.
 *
 * The projection's first snapshot is the END of the current year — it already
 * includes a year of growth, contributions and withdrawals — so using it for a
 * figure labelled "today" overstates what someone actually has. On the sample
 * plan that gap is over 5%, which is enough to make a careful person distrust
 * every number under it. Anything labelled "today" should come from here.
 */
import type { Plan } from './types';
import { ownedInYear } from '../engine/realEstate';
import { CURRENT_YEAR } from './defaults';

export function netWorthToday(plan: Plan, year = CURRENT_YEAR): number {
  const accounts = plan.accounts.reduce((t, a) => t + a.balance, 0);
  const property = plan.properties
    .filter((p) => ownedInYear(p, year))
    .reduce((t, p) => t + p.currentValue, 0);
  const debts = plan.debts.reduce((t, d) => t + d.balance, 0);
  return accounts + property - debts;
}
